import { ConfirmItemButton } from '@/components/buttons/ConfirmItemButton';
import { VisitRequestState, VisitRequestWorkflowStep } from '@/types/graphql';
import { ScheduleSend } from '@mui/icons-material';
import { Chip } from '@mui/material';

import { VisitState } from '../../types/visit';
import { VisitRequestStateChip } from '../visitRequests/VisitRequestStateChip';
import { VisitRequestWorkflowStepChip } from '../visitRequests/VisitRequestWorkflowStepChip';
import { usePromoteVisitRequest } from '../visitRequests/mutations/promoteVisitRequest';
import { VisitStateChip } from '../visits/StatusAndOutcomeChips';

export const WorkflowStepCountChip = ({ count }: { count: number }) => {
    return count > 0 ? <Chip size='small' label={count} /> : null;
};

// Hoisted so re-renders reuse the same sx reference (no Emotion re-serialization).
const PROMOTE_BUTTON_SX = {
    borderRadius: 2,
    textTransform: 'none',
} as const;
export function PromoteVisitRequestButton({ visitRequestId }: { visitRequestId: string }) {
    const { promoteVisitRequest, loading, client } = usePromoteVisitRequest({
        visitRequestId,
    });

    async function handlePromoteVisitRequest() {
        await promoteVisitRequest();
        await client.refetchQueries({
            // TODO(jessica): Refine this
            include: 'active',
        });
    }

    return (
        <ConfirmItemButton
            startIcon={<ScheduleSend />}
            tooltip='Ready for Scheduling'
            size='small'
            disabled={loading}
            sx={PROMOTE_BUTTON_SX}
            onClick={(event) => {
                event.stopPropagation();
                void handlePromoteVisitRequest();
            }}
        >
            Ready
        </ConfirmItemButton>
    );
}

export const InteractiveVisitRequestStateCell = ({
    visitRequest,
}: {
    visitRequest: {
        id: string;
        state: VisitRequestState;
        visitRequestWorkflowStep: VisitRequestWorkflowStep;
    };
}) => {
    if (visitRequest.state === VisitRequestState.PENDING) {
        switch (visitRequest.visitRequestWorkflowStep) {
            case VisitRequestWorkflowStep.COMPLETED:
                // This gives an "optimistic update" effect of showing the
                // transition to unscheduled visit more immediately.
                return <VisitStateChip state={VisitState.UNSCHEDULED} />;
            case VisitRequestWorkflowStep.READY_FOR_PROMOTION:
                return <PromoteVisitRequestButton visitRequestId={visitRequest.id} />;
            default:
                return (
                    <VisitRequestWorkflowStepChip
                        workflowStep={visitRequest.visitRequestWorkflowStep}
                    />
                );
        }
    } else if (visitRequest.state === VisitRequestState.FULFILLED) {
        return <VisitStateChip state={VisitState.UNSCHEDULED} />;
    }
    return <VisitRequestStateChip state={visitRequest.state} />;
};
